"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_button_1 = require("@ryerson/frontend.button");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_modal_1 = require("@ryerson/frontend.modal");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var util_1 = require("../common/util");

var Container = (0, styled_1.default)(frontend_layout_1.Flex)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: 600px;\n\tpadding: 30px 0;\n"])));

var MergeCartModalDesktop = function MergeCartModalDesktop(_ref) {
  var content = _ref.content,
      showMergeCartModal = _ref.showMergeCartModal,
      setShowMergeCartModal = _ref.setShowMergeCartModal,
      numberOfItems = _ref.numberOfItems;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var darkGray = theme.colors.primary.darkGray;
  return (0, jsx_runtime_1.jsx)(frontend_modal_1.Modal, {
    title: content.title.replace(/%plural%/g, numberOfItems > 1 ? "s" : ""),
    dataTestId: "save-as-quote-modal",
    type: "primary",
    modalStyle: "default",
    isOpen: showMergeCartModal,
    closable: true,
    onClose: function onClose() {
      return setShowMergeCartModal(false);
    },
    buttonArea: (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
      css: {
        width: "100%"
      },
      justifyContent: "flex-start",
      children: [(0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
        css: {
          width: "200px",
          marginRight: "20px"
        },
        fullwidth: true,
        onClick: function onClick() {
          return setShowMergeCartModal(false);
        },
        label: content.ok
      }), (0, jsx_runtime_1.jsx)(frontend_button_1.Button, {
        css: {
          width: "200px"
        },
        onClick: function onClick() {
          return (0, util_1.navigateLink)("/store", "/cart");
        },
        fullwidth: true,
        foreground: "light",
        background: darkGray,
        label: content.reviewCart
      })]
    }),
    children: (0, jsx_runtime_1.jsx)(Container, {
      children: (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        children: content.message.replace(/%number%/g, "".concat(numberOfItems)).replace(/%plural%/g, numberOfItems > 1 ? "s" : "")
      })
    })
  });
};

exports.default = MergeCartModalDesktop;